export default __webpack_public_path__ + "static/media/axion-today-dark.62850a38.png";